import { AHCREvent } from 'domain/ahcr-event'
import { downloadCsv, buildCsvFilename } from 'shared/utils/csv-export'

const CSV_HEADERS = [
  'Câmera',
  'Data/Hora',
  'Gênero',
  'Faixa Etária',
  'Cabelo',
  'Tipo de Blusa',
  'Cor da Blusa',
  'Tipo de Calça',
  'Cor da Calça',
  'Chapéu',
  'Máscara',
  'Óculos',
  'Bolsa',
  'Permanência (s)',
  'URL Imagem Aproximada',
  'URL Imagem Detecção',
]

const formatRow = (event: AHCREvent): (string | number)[] => {
  const date = new Date(event.createdDate).toLocaleString('pt-BR')
  return [
    event.cameraName ?? '',
    date,
    event.gender ?? '',
    event.ageGroup ?? '',
    event.hairStyle ?? '',
    event.jacketType ?? '',
    event.jacketColor ?? '',
    event.trousersType ?? '',
    event.trousersColor ?? '',
    event.hat ?? '',
    event.mask ?? '',
    event.glass ?? '',
    event.bag ?? '',
    event.stayDuration ?? '',
    event.closeUpImageUrl ?? '',
    event.detectionImageUrl ?? '',
  ]
}

export const exportAHCREventsToCSV = (
  events: AHCREvent[],
  filename?: string
): void => {
  downloadCsv(CSV_HEADERS, events.map(formatRow), filename ?? buildCsvFilename('eventos-ahcr'))
}
